import { Typography } from '@tempmee/react';
import { colors } from '@tempmee/tailwind';

export const GotReferredSection = () => {
  return (
    <>
      <Typography as="span" size="heading_4" bold color={colors.primary[500]} style={{ paddingTop: 32 }}>
        Got Referred? Enter Their Link to{' '}
        <Typography as="span" size="heading_4" bold color={colors.success[400]}>
          Start Earning
        </Typography>
      </Typography>

      <Typography as="span" textAlign="center" color={colors.neutral[500]} style={{ marginTop: 20 }}>
        If a colleague or professional referred you, enter their link below. <br />
        Once you both complete your first shift, you&apos;ll each receive a <br />
        reward as a thank you from GoTu!
      </Typography>
    </>
  );
};
